import About from '../components/About/About';

export default function AboutPage() {
  return (
    <main>
      <About />
    </main>
  );
}
